import assert from 'shared/utils/assert'
import {
  type AdServerContext,
  type AdServerRequestUser,
} from 'types/adServerTypes'

import BackendAPIService from './BackendAPIService'
import { type ServiceParameters } from './commonTypes/ServiceParameters'

export type GkAirRecommendationsWebResponse = {
  recommendations?: GenericRecord
  [key: string]: unknown
}

type AdServerData = {
  context: AdServerContext
  keywords?: Array<string>
  eventIds?: Array<number>
  user: AdServerRequestUser
}

type RequestPayload = { adServerData: AdServerData } | undefined

type FetchGkAirRecommendationsParams = {
  serviceId: string
  params?: GenericRecord
  adServerData?: AdServerData
}

class GkAirService extends BackendAPIService {
  private readonly basePath: string

  constructor(params: ServiceParameters) {
    super(params)

    this.basePath = '/crosssellers-proxy-service/gk-air/web/recommendation'
  }

  public async fetchRecommendations({
    serviceId,
    params = {},
    adServerData,
  }: FetchGkAirRecommendationsParams): Promise<GkAirRecommendationsWebResponse> {
    assert(
      serviceId,
      'GkAirService:fetchRecommendations(): no "serviceId" option provided'
    )

    const payload: RequestPayload = adServerData ? { adServerData } : undefined

    const { data } = await this.post<
      RequestPayload,
      GkAirRecommendationsWebResponse
    >(`${this.basePath}/${serviceId}`, payload, {
      params: {
        language: this.language,
        tenant: this.tenantPath,
        ...params,
      },
    })

    return data
  }
}

export default GkAirService
